import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function TrustBadges() {
  return <>
      <div className="flex flex-col items-center gap-4" data-id="element-231">
        <div className="flex items-center gap-4 md:gap-5 flex-wrap justify-center" data-id="element-232">
          {/* Mercado Pago */}
          <div className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-md px-4 py-2.5" data-id="element-233">
            <img src="https://cdn.magicpatterns.com/uploads/5anDiPc7wgfSmYDiMpdcR8/Captura_de_pantalla_29-3-2026_23105_www.mercadopago.com.mx.jpg" alt="Mercado Pago" className="w-9 h-9 object-contain rounded-sm" data-id="element-234" />
            <span className="text-sm text-gray-200 font-sans font-medium hidden sm:inline" data-id="element-235">
              Mercado Pago
            </span>
          </div>

          {/* Visa */}
          <div className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-md px-4 py-2.5" data-id="element-236">
            <svg viewBox="0 0 40 24" className="w-14 h-9" fill="none" data-id="element-237">
              <rect width="40" height="24" rx="4" fill="#1A1F71" data-id="element-238" />
              <path d="M17.2 8.2l-2.6 7.6h-2.1l-1.3-6c-.1-.3-.2-.5-.5-.6-.5-.3-1.3-.5-2-.7l.1-.3h3.3c.4 0 .8.3.9.8l.8 4.4 2.1-5.2h2.1zm8.3 5.1c0-2-2.8-2.1-2.8-3 0-.3.3-.5.7-.6.6 0 1.2.1 1.7.3l.3-1.5c-.5-.2-1.2-.4-2-.4-2.1 0-3.5 1.1-3.5 2.6 0 1.2 1 1.8 1.8 2.2.8.4 1 .6 1 1 0 .5-.6.8-1.2.8-.7 0-1.4-.2-1.8-.4l-.3 1.5c.6.2 1.3.3 2.1.3 2.2 0 3.6-1.1 3.6-2.7zm5.5 2.5h1.8l-1.6-7.6h-1.7c-.4 0-.7.2-.8.5l-3 7.1h2.1l.4-1.1h2.5l.3 1.1zm-2.2-2.7l1-2.9.6 2.9h-1.6zm-8.3-4.9l-1.6 7.6h-2l1.6-7.6h2z" fill="white" data-id="element-239" />
            </svg>
            <span className="text-sm text-gray-200 font-sans font-medium hidden sm:inline" data-id="element-240">
              Visa
            </span>
          </div>

          {/* Mastercard */}
          <div className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-md px-4 py-2.5" data-id="element-241">
            <svg viewBox="0 0 40 24" className="w-14 h-9" fill="none" data-id="element-242">
              <rect width="40" height="24" rx="4" fill="#000" data-id="element-243" />
              <circle cx="16" cy="12" r="7" fill="#EB001B" data-id="element-244" />
              <circle cx="24" cy="12" r="7" fill="#F79E1B" data-id="element-245" />
              <path d="M20 6.8a7 7 0 000 10.4 7 7 0 000-10.4z" fill="#FF5F00" data-id="element-246" />
            </svg>
            <span className="text-sm text-gray-200 font-sans font-medium hidden sm:inline" data-id="element-247">
              Mastercard
            </span>
          </div>
        </div>
        {/* Satisfaction Badge */}
        <div className="flex items-center gap-2 bg-gold/5 border border-gold/20 rounded-md px-4 py-2.5" data-id="element-248">
          <ShieldCheck className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-249" />
          <div className="flex flex-col" data-id="element-250">
            <span className="text-xs text-gold font-sans font-bold leading-tight" data-id="element-251">
              Acceso Seguro
            </span>
            <span className="text-[10px] text-gray-400 font-sans leading-tight" data-id="element-252">
              Satisfacción Garantizada
            </span>
          </div>
        </div>
      </div>

      <p className="text-xs text-gray-500 font-sans tracking-wide text-center" data-id="element-253">
        Pago 100% seguro en pesos argentinos. Acreditación inmediata.
      </p>
    </>;
}